let release: (() => void) | undefined;

/** Hold the clicked row through lazy remeasurement, until the next user interaction. */
export function preserveListAnchor(id: string) {
  release?.();
  const list = document.querySelector<HTMLElement>(".lscroll");
  const find = () => list?.querySelector<HTMLElement>(`[data-id="${CSS.escape(id)}"]`);
  const row = find();
  if (!list || !row || !list.getClientRects().length) return;
  const y = row.getBoundingClientRect().top - list.getBoundingClientRect().top;
  const previous = list.style.overflowAnchor;
  list.style.overflowAnchor = "none"; // one owner of scroll position during the handoff
  let stopped = false;
  const restore = () => {
    const row = find();
    if (stopped) return;
    if (!list.isConnected || !row) { stop(); return; }
    if (!list.getClientRects().length) return;
    const box = row.getBoundingClientRect(), viewport = list.getBoundingClientRect();
    const top = Math.max(0, Math.min(y, list.clientHeight - box.height));
    const delta = box.top - viewport.top - top;
    if (Math.abs(delta) > 0.5) list.scrollTop += delta;
  };
  const observer = new ResizeObserver(restore);
  observer.observe(list);
  observer.observe(row);
  // content-visibility can correct skipped rows after the column's first layout.
  // Groups, rather than individual rows, expose those height changes cheaply.
  for (const child of list.children) observer.observe(child);
  const stop = () => {
    if (stopped) return;
    stopped = true;
    observer.disconnect();
    list.style.overflowAnchor = previous;
    for (const event of events) document.removeEventListener(event, stop, true);
    if (release === stop) release = undefined;
  };
  const events = ["wheel", "touchstart", "pointerdown", "keydown"];
  for (const event of events) document.addEventListener(event, stop, { passive: true, capture: true });
  release = stop;
  return { restore, stop };
}
